const COMPACT_TIERS = [
  { divisor: 1_000_000_000, suffix: 'B' },
  { divisor: 1_000_000, suffix: 'M' },
  { divisor: 1_000, suffix: 'K' },
] as const;

function trimTrailingDotZero(s: string): string {
  return s.replace(/\.0$/, '');
}

export function formatCompactCount(value: number): string {
  if (!Number.isFinite(value)) {
    return '—';
  }
  const sign = value < 0 ? '-' : '';
  const v = Math.abs(value);
  if (v === 0) {
    return '0';
  }
  if (v < 1000) {
    const rounded = Math.round(v * 100) / 100;
    return sign + (Number.isInteger(rounded) ? String(rounded) : String(rounded));
  }
  for (const { divisor, suffix } of COMPACT_TIERS) {
    if (v >= divisor) {
      const scaled = v / divisor;
      if (scaled >= 100) {
        return sign + String(Math.round(scaled)) + suffix;
      }
      return sign + trimTrailingDotZero(scaled.toFixed(1)) + suffix;
    }
  }
  return sign + String(v);
}

export function formatCompactUsagePair(
  usedStr: string,
  limitStr: string,
): { short: string; full: string } | null {
  const u = Number(usedStr);
  const l = Number(limitStr);
  if (!Number.isFinite(u) || !Number.isFinite(l)) {
    return null;
  }
  return {
    short: `${formatCompactCount(u)} / ${formatCompactCount(l)}`,
    full: `${usedStr} / ${limitStr}`,
  };
}
